import React from "react";
import ChatInterface from "../component/ChatInterface";

// const ChatContainer = () => (<TaskLayout><Team /></TaskLayout>)
const ChatInterfaceContainer = () => (<ChatInterface />)

export default ChatInterfaceContainer;
